import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import PublicMachine from "@/pages/PublicMachine";
import Legal from "@/pages/Legal";
import About from "@/pages/About";
import Grazie from "@/pages/Grazie";
import ResetPassword from "@/pages/ResetPassword";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/m/:id" element={<PublicMachine />} />
                <Route path="/legal/:type" element={<Legal />} />
                <Route path="/about" element={<About />} />
                <Route path="/grazie" element={<Grazie />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/admin" element={<AdminPage />} />
                </Route>
              </Routes>
            </SmoothScroll>
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
